import LogoPic from "../assets/10DayOfCodeLogo.png"
import "./Logo.css"

const Logo = () => {

    return(
        <div className="Logo">
            <img src={LogoPic} alt="" />
        </div>
    )
}

export default Logo